import React from 'react';
import PropTypes from 'prop-types';

const parseDate = (date) => {
  const dateParts = date.split('-');
  const year = dateParts[0];
  const month = parseInt(dateParts[1], 10) - 1;
  const day = dateParts[2];

  return new Date(year, month, day);
};

const SingleDate = ({ date }) => {
  const dateObject = parseDate(date);
  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return <time dateTime={date}>{formatter.format(dateObject)}</time>;
};

const DateRange = ({ startDate, endDate }) => {
  if (startDate === endDate) {
    return <SingleDate date={startDate} />;
  }

  const startDateObject = parseDate(startDate);
  const endDateObject = parseDate(endDate);
  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

  return (
    <time dateTime={startDate}>
      {formatter.formatRange(startDateObject, endDateObject)}
    </time>
  );
};

const FormattedDate = ({ date, startDate, endDate }) => {
  if (date) {
    return <SingleDate date={date} />;
  }

  if (startDate && endDate) {
    return (
      <DateRange
        startDate={startDate}
        endDate={endDate}
      />
    );
  }

  return null;
};

FormattedDate.propTypes = {
  date: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};

export default FormattedDate;
